(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-registration/assets/service/service.js') >= 0) return;  svs.modules.push('/modules/player-registration/assets/service/service.js');
'use strict';

const isServer = typeof exports === 'object';
let logger;
let jupiter;
if (isServer) {
  const trinidad = require('@svenskaspelab/trinidad-core').core;
  jupiter = trinidad.jupiter;
  logger = trinidad.logger('playerRegistration');
} else {
  jupiter = svs.core.jupiter;
  logger = svs.playerRegistration.logger;
}

const streamlinedJupiterCall = async options => {
  let response;
  let status;
  try {
    var _response;
    if (isServer) {
      const apiResponse = await jupiter.callAsync(options);
      status = apiResponse ? 'success' : 'Api response missing';
      response = apiResponse;
    } else {
      ({
        response,
        status
      } = await jupiter.callAsync(options));
    }
    return {
      error: status === 'success' ? null : ((_response = response) === null || _response === void 0 ? void 0 : _response.error) || 'error',
      data: status === 'success' ? response : null
    };
  } catch (err) {
    logger.warn("Error getting ".concat(options.path), err);
    return {
      error: err,
      data: null
    };
  }
};
const getComplianceAsync = async (customer, req) => {
  const path = customer.eid && customer.eid === 'frejaeid' ? '/player/1/registration/compliance/frejaeid' : '/player/1/registration/compliance';
  const options = {
    method: 'POST',
    path,
    data: {
      postToken: customer.token
    },
    req
  };
  const {
    data,
    error
  } = await streamlinedJupiterCall(options);
  return {
    data,
    error
  };
};
const registerCustomerAsync = async (customerData, eid, req) => {
  const path = eid && eid === 'frejaeid' ? '/player/1/registration/frejaeid' : '/player/1/registration/bankid';
  const options = {
    method: 'PUT',
    path,
    data: customerData
  };
  if (isServer) {
    options.req = req;
  }
  const {
    data,
    error
  } = await streamlinedJupiterCall(options);
  return {
    data,
    error
  };
};
const getUserPreferencesAsync = async () => {
  const options = {
    method: 'GET',
    path: '/player/1/preferences'
  };
  const {
    data,
    error
  } = await streamlinedJupiterCall(options);
  return {
    data,
    error
  };
};
const confirmEmailCustIdKundvillkorAndKycStatus = (userPrefs, responseKycStatus) => {
  var _userPrefs$preference;
  return (
    userPrefs ? (userPrefs === null || userPrefs === void 0 || (_userPrefs$preference = userPrefs.preferences['30']) === null || _userPrefs$preference === void 0 ? void 0 : _userPrefs$preference.email) && userPrefs.preferences['30'].declaredcustomerid && userPrefs.preferences['50']['kundvillkor-och-info-pu'] && Boolean(JSON.parse(userPrefs.preferences['50']['kundvillkor-och-info-pu']).accepted) && parseInt(userPrefs.preferences['30'].kycStatus, 10) === responseKycStatus : false
  );
};
const confirmEmailCustIdAndKundvillkor = userPrefs => {
  var _userPrefs$preference2;
  return (
    userPrefs ? (userPrefs === null || userPrefs === void 0 || (_userPrefs$preference2 = userPrefs.preferences['30']) === null || _userPrefs$preference2 === void 0 ? void 0 : _userPrefs$preference2.email) && userPrefs.preferences['30'].declaredcustomerid && userPrefs.preferences['50']['kundvillkor-och-info-pu'] && Boolean(JSON.parse(userPrefs.preferences['50']['kundvillkor-och-info-pu']).accepted) : false
  );
};
const checkFreshPreferencesDataAsync = responseKycStatus => new Promise(resolve => {
  const maxRetries = 5;
  let counter = 0;
  const prefInterval = setInterval(async () => {
    const response = await getUserPreferencesAsync();
    const confirmed = responseKycStatus ? confirmEmailCustIdKundvillkorAndKycStatus(response.data, responseKycStatus) : confirmEmailCustIdAndKundvillkor(response.data);
    counter++;
    if (confirmed) {
      clearInterval(prefInterval);
      logger.info("Fetched preferences in checkFreshPreferencesDataAsync. Attempt number: ".concat(counter, "."));
      resolve({
        data: response.data,
        error: null
      });
    } else if (counter < maxRetries) {
      logger.info("Error fetching preferences in checkFreshPreferencesDataAsync. Attempt number: ".concat(counter, ". Try again."), (response === null || response === void 0 ? void 0 : response.error) || '');
    } else {
      clearInterval(prefInterval);
      logger.info("Error fetching preferences in checkFreshPreferencesDataAsync. Attempt number: ".concat(counter, ". No more retries."), (response === null || response === void 0 ? void 0 : response.error) || '');
      resolve({
        data: null,
        error: 'Something went wrong when trying to fetch preferences. No more retries.'
      });
    }
  }, 1000);
});
const exportedFunctions = {
  getComplianceAsync,
  registerCustomerAsync,
  getUserPreferencesAsync,
  checkFreshPreferencesDataAsync
};

if (isServer) {
  module.exports = exportedFunctions;
} else {
  svs.playerRegistration.service = exportedFunctions;
}

 })(window);